<template>
  <div v-if="isLoggedIn && sgDetails.length > 0" class="mb16">
    <div class="col-sm-12 col-md-12 col-lg-12 mb12 sg-one-click-widget" v-if="sgDetails.length == 1">
      <div class="sg-one-click-widget__container">
        <img
              :src="imgBaseUrl + '/' + sgDetails[0].imgUrl"
              alt="30 minutes delivery"
              width=""
              height=""
              class=""
        />
        <div class="sg-one-click-widget__header fs-14 tl">
            {{ sgDetails[0].title }}
        </div>
        <div class="sg-one-click-widget__content flex-row align-items-center justify-content-between">
          <div class="flex-column gap4 align-items-start">
            <span class="fw-600 tl">{{ sgDetails[0].text }}</span>
            <span class="fw-500 tl">Delivered on {{ currentFormattedDate }} • Valid till {{ validTillFormattedDate }}</span>
          </div>
          <button @click="handleClaimRefund" class="line-btn sg-claim-btn ripple">Claim Refund</button>
        </div>
      </div>
    </div>
    <div class="flex-column nxg-track-ord scroll-target" v-else-if="sgDetails.length > 1">
        <Carousel
          v-model="currentIndex"
          :items-to-show="1"
          :wrap-around="false"
          :mouse-drag="true"
          :touch-drag="true"
          :transition="400"
          :snap-align="'center'"
        >
          <Slide v-for="(sgItem, index) in sgDetails" :key="index">
            <div class="sg-one-click-widget__container">
              <img
                    :src="imgBaseUrl + '/' + sgItem.imgUrl"
                    alt="30 minutes delivery"
                    width=""
                    height=""
                    class=""
              />
              <div class="sg-one-click-widget__header fs-14 tl">
                  {{ sgItem.title }}
              </div>
              <div class="sg-one-click-widget__content flex-row align-items-center justify-content-between">
                <div class="flex-column gap4 align-items-start">
                  <span class="fw-600 tl">{{ sgItem.text }}</span>
                  <span class="fw-500 tl">Delivered on {{ currentFormattedDate }} • Valid till {{ validTillFormattedDate }}</span>
                </div>
                <button @click="handleClaimRefund" class="line-btn sg-claim-btn ripple">Claim Refund</button>
              </div>
            </div>
          </Slide>
          <template #addons>
            <Pagination />
          </template>
        </Carousel>
    </div>
    <!-- Claim Refund Bottom Sheet -->
    <div class="black-overlay" v-if="showBottomSheet" @click="hideBottomSheet"></div>
    <transition name="slide-up" mode="out-in">
      <div class="claim-refund-bottom-sheet" v-if="showBottomSheet">
        <sg-one-click-bottom-sheet
          :sgData="sgDetails[currentIndex]"
          @close-bottom-sheet="hideBottomSheet"
        />  
      </div>
    </transition>
  </div>
</template>

<script>

import { Carousel, Slide, Pagination } from "vue3-carousel";
import 'vue3-carousel/dist/carousel.css';
import { keyMapsAction, keyMapsMutation } from "../helpers/storeKeys";
import { imgBaseUrl } from "../config/apiEndpoints";
import SgOneClickBottomSheet from "./SgOneClickBottomSheet.vue";
import { fireSgOneClickAmplitudeEvent } from "../helpers/utility";
import localStorageFunc from "../helpers/localStorageFunc";

export default {
  components: { 
    Carousel,
    Slide,
    Pagination,
    SgOneClickBottomSheet
  },
  name: "SgOneClickWidget",
  props: ["data", "moduleProps"],
  data() {
    return {
      totalTime: 15,
      timeLeft: 15,
      timerInterval: null,
      modulePropsData: {},
      currentIndex: 0,
      showBottomSheet: false,
      apiEndpoint: "/order-service/ve1/sg/eligible",
      imgBaseUrl: imgBaseUrl,
      apiFlag: false,
    };
  },
  mounted() {
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined" &&
      this.moduleProps != 'null'
        ? JSON.parse(this.moduleProps)
        : {};
  },
  watch: {
    currentIndex(newVal, oldVal) {
      const sgData = this.sgDetails[newVal];
      const timeServiceData = sgData?.timeServiceGuarantee || {};
      fireSgOneClickAmplitudeEvent('SG_refund_impression', "nextgen home screen", 'impression', 'SG_refund_claim', timeServiceData?.amount, timeServiceData?.type);
    },
  },
  computed: {
    isLoggedIn() {
      const flag = localStorageFunc.isLoggedIn() || false;
      if(flag && !this.apiFlag){
        setTimeout(() => {
          this.apiFlag = true;
          this.$store.dispatch(keyMapsAction.GET_SG_ONECLICK_DATA, {
            apiUrl: this.modulePropsData?.url ? this.modulePropsData?.url : this.apiEndpoint
          });
        }, 100);
      }

      return flag;
    },
    sgDetails() {
      const sgDetails = this.$store.state.SgOneClick.sgOneClickWidgetData || [];
      if (sgDetails.length === 0) {
        return [];
      }
      const sgData = sgDetails[0];
      const timeServiceData = sgData?.timeServiceGuarantee || {};
      fireSgOneClickAmplitudeEvent('SG_refund_impression', "nextgen home screen", 'impression', 'SG_refund_claim', timeServiceData?.amount, timeServiceData?.type);
      return sgDetails;
    },
    currentFormattedDate() {
      const validDate = new Date(this.sgDetails[this.currentIndex].deliveryTimeStamp);
      return validDate.toLocaleDateString("en-GB", { day: "2-digit", month: "short" });
    },
    validTillFormattedDate() {
      const validDate = new Date(this.sgDetails[this.currentIndex].expiryTimeStamp);
      return validDate.toLocaleDateString("en-GB", { day: "2-digit", month: "short" });
    },
    refundAmt() {
        return this.sgDetails[this.currentIndex]?.timeServiceGuarantee?.amount || 0;
    },
    formattedTime() {
      const seconds = String(this.timeLeft).padStart(2, "0");
      return `00:${seconds}`;
    }
  },
  methods: {
    handleClaimRefund() {
      this.showBottomSheet = true;
    },
    hideBottomSheet() {
      this.showBottomSheet = false;
      this.$store.commit(keyMapsMutation.UPDATE_SG_CREATE_STATE, ''); // reset sg create status
      this.$store.commit(keyMapsMutation.UPDATE_SG_POLLING_STATE, ''); // reset sg polling status
      this.$store.commit(keyMapsMutation.UPDATE_IS_SG_BOTTOM_SHEET_OPEN, false); // reset bottom sheet open state
    }
  }
};

</script>